/* eslint-disable */

import { generic_service } from '../_utilities/generic.js'
import api from '../_api'

const genericProfileService = (pathname) => ({
  getAllProfilesStats(range) {
    return api.get('/profile/stats_range/', {
      params: { range },
    })
  },
  getProfileStats(pk, range) {
    return api.get(`/profile/${pk}/single_stats_range/`, {
        params: { range }
    })
  },
  getStylistGroups(id, payload) {
    return api.get(`/customer-group/${id}/assigned_stylist/`, { params: payload })
  },
  getSalesOverviewData(id) {
    return api.get(`profile/${id}/sales_overview/`);
  },
  getCustomSalesOverviewData(url, payload) {
    return api.get(url, {params: payload})
  },
  getOrderedItems(payload) {
    return api.get(`profile/assign_list/`, {params: payload});
  },
  fetchTeam(url) {
    return api.get(url);
  },
  ...generic_service(pathname),
})

export default genericProfileService;
